/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import { getSDGShortTitle } from '../../constants/sdg-data';
import NumberFormat from '../../utils/number-format';
import { SDG_CODES } from '../../constants/utr';
import { generateId } from '@utils/index';
import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';
import './styles.scss';

interface Props {
  goals: Record<number, number> | undefined;
  tooltipPrefix?: JSX.Element;
  handleClick?: (code: number) => void;
}

export const ScorecardStatusbar = ({ goals, tooltipPrefix, handleClick }: Props) => {
  if (!goals) {
    return null;
  }

  const uniqueId = generateId();

  const getTooltip = (sdgCode: string | number, score: number) => {
    return (
      <div>
        {tooltipPrefix}
        <div>
          SDG {sdgCode}: {getSDGShortTitle(sdgCode)}: <NumberFormat value={score} suffix={'%'} />
        </div>
      </div>
    );
  };

  return (
    <div className='scorecard-statusbar'>
      {SDG_CODES.map((sdgCode) => {
        const enabled = goals[sdgCode] && goals[sdgCode] > 0;
        const className = enabled ? 'sdg-bg-' + sdgCode + '-5' : 'background-ThemeNeutralsLight';
        const id = `sdgstatusbar-${uniqueId}-${sdgCode}`;
        return (
          <SimpleTooltip key={id} text={getTooltip(sdgCode, goals[sdgCode])}>
            <div
              onClick={handleClick ? () => handleClick(sdgCode) : undefined}
              className={`sdg-block ${className} ${handleClick ? 'clickable' : ''}`}
            />
          </SimpleTooltip>
        );
      })}
    </div>
  );
};
